export const ui_strings = [

"-1 :intrigue: on same location or Character in same location.",
"-1 :intrigue: on Shrine.",
"-1 :paranoia: on character in same location.",
"-1 :paranoia: on panicked character in same location. This ability cannot be refused by :goodwill: Refusel.",
"-1 :paranoia: on student in same location.",
":alice: must be a girl.",
":goodwill: Outburst",
":keyPerson: and :fragment: both must be a :girl:.",
":keyPerson: and :vampire: must be of oposing sex.",
":keyPerson: gets +1 :goodwill:.",
":keyPerson: must be a :girl:.",
":lastWill: or :leftBehind: has triggered this loop.",
":madGenius: acquirs Body Parts.",
":madGenius: has Body Parts and is alive",
":nightMadness: occurred this day",
":seeder: is killed.",
":supplicant: is alive and has the :supernaturalTag: tag",
":vampire and :nightmare: must be the same sex.",
":worldConvergence: hasn‘t occured this loop.",
"\":promiseSmile:\" Loss condition was met in the previous Loop.",
"\"Forbid :goodwill:\" has the effect of \"Forbid Movement\"",
"(If the Extra Gauge is at zero, the Protagonists always lose)",
"(optional) The protagonists die during the Day end.",
"(Sum of the Extra Gauge and the number of :intrigue: counters on the :obstinate: added by this Plot) is 3 or more.",
"[When determinig wether this Incident triggers or not, treat the culprit’s :paranoia: limit as 1 more than its printed limit.] Resolve \":sserialMurder:\" and \":increasingUnease:\" in that order. Then increase the Extra Gauge by 1 more step.",
"[When determining whether this Incident triggers or not, treat the culprit’s :paranoia: limit as 2 less than its printed limit.] Increase Extra Gauge by 1, then the Protagonist Leader chooses one character. That character is killed.",
"[When determning wether this Incident triggers or not, treat the culprit’s :paranoia: limit ats 1 less then its printed limit] Put 1 :paranoia: counter on any character in the culprit’s location.",
"{days} per {type}",
"˝:butterflyEffect:˝ has occured this loop.",
"+/-1 :paranoia: on character in same location.",
"+1 :goodwill: and -1 :paranoia: on a character in this Location. You can then transfer the EX Card to another character in the same area (who is not the :uploader:).",
"+1 :goodwill: on character in same location.",
"+1 :intrigue: on this Location or any character in this Location.",
"+1 :paranoia: on any other character.",
"1 :intrigue: on the City",
"1 :intrigue: on the culprit",
"1 :intrigue: on the Hospital",
"1 :intrigue: on the School",
"1 or more :hope: counters on the Key Person.",
"1. The Extra gauge starts on zero and dose not reset between loops. 2. Every time :goodwill: ability is refused, immediately increase the Extra Gauge. 3. The Extra Gauge unlooks spells for the characters (Level in parenthises behind the spell name).",
"2 :intrigue: on the :brain:’s starting location",
"2 :intrigue: on the :keyPerson:.",
"2 :intrigue: on the :witch:’s starting location.",
"2 :intrigue: on the City",
"2 :intrigue: on the culprit’s starting location",
"2 :intrigue: on the Hospital",
"2 :intrigue: on the School",
"2 :intrigue: on the School.",
"2 :intrigue: on the Shrine.",
"2+ :intrigue: on School.",
"2+ :intrigue: on the :witch:'s starting Location.",
"2+ :intrigue: on the Shrine.",
"3+ :intrigue: on a :person:.",
"3+ :paranoia:, or 1+ :intrigue:",
"3+ :paranoia:.",
"4 or more kinds of counters on this character",
"6 or more zombies when this incident occurs.",
"A Character died the last turn.",
"A corpse whose original role does not have :afterDeath: activity will be changed to a :zombie: as long as it has at least 1 :intrigue:.",
"A Drop of Strychnine",
"A fan wiki with lots of information.",
"A Hideous Script",
"A Location where a character with :goodwill: Refusel is.",
"A Love Affair",
"A Place to Protect",
"A playlist for Tragedy Looper",
"A Quilt of Incidents",
"A Strange Story",
"A Suspicious Letter",
"A website to generate scripts",
"A website to play Tragedy Looper Online, with an English interface and cards.",
"A.I.",
"abductions",
"Abductions",
"abilities",
"Abilities",
"Abilities Mastermind",
"Abilities Protagonists",
"abnormal or normal",
"Abnormal World",
"abomination",
"Abomination",
"Action card set on a corpse that has no :afterDeath: activity (+1) Declaration of using :goodwill: abilities of corpse that has no After Death activity (+1) Using :goodwill: ability to corpse that has no :afterDeath: activity (+1) Subplot :deepHole: at the end of the loop (+ 0-3) Role Ability of :monster: (+2) Role Ability of :zombie: (+1) Incident Effect (:sacrifice:, :repeatingNightmare:) (+1).",
"active",
"Add 1 :paranoia: to any character.",
"Add 1 :paranoia: to every character.",
"Add an :intrigue: to all Characters at the Culprit's location.",
"Add one :intrigue: to a Character and one :intrigue: to that Character's location.",
"Add one :paranoia: to a character in this location.",
"Add one :paranoia: to another non-:supernaturalTag: chracter in the same Location and change the Characters role to :keyPerson:. Teh :seeder: looses all abilities and Effects after using this ability.",
"Additional Links",
"addRolesForPlot",
"aditionalRoles",
"adult",
"Adult",
"After Death",
"after death",
"After Goodwill Ability used",
"After I include your text, everyone should be able to see the translations online  Currently, your translations are stored in your browser, so you can check if it works as intended. These are marked with «»",
"After resolving this character's :goodwill: ability",
"After that, if that location has 5 or more corpses",
"After this character has triggered an Incident, remove all :paranoia: counters from this card.",
"afterdeath",
"agent",
"Agent",
"agitator",
"Agitator",
"ai",
"Album of Memories",
"albumMemories",
"alice",
"Alice",
"alien",
"Alien",
"Alien Erosion",
"alienErosion",
"All :person:s with at least 3 :paranoia: turn into :serialKiller:s.",
"All characters and the Protagonists are killed.",
"All characters die.",
"All Characters in School are killed.",
"All characters in the culprit’s location are killed.",
"All characters in the location become :facsimile:s.",
"All characters whose original role is :person: gain :goodwill: Outburst.",
"All corpses that had the role :person:, :coward: or :showOff: change into having the role of :zombie:",
"All roles have not been revealed.",
"All types of :goodwill: Refusel become Puppeted :goodwill: Refusel (including mandatory :goodwill: Refusel and that granted by :despair: counters).",
"Allow editing locally stored translations",
"Allow editing missing translations",
"Allowed Values",
"Alternate Card Names",
"Alternate character images",
"Always",
"Always has a role not associated with current plot.",
"Always include suprise characters",
"An Absolute Will",
"An Unsettling Rumor",
"anAbsoluteWill",
"Ancient Seal (3)",
"Ancient Shrine",
"ancientShrine",
"animal",
"Animal",
"animus",
"Animus",
"Another Horizon",
"Another Horizon R",
"anotherHorizon",
"anotherHorizonR",
"As manay or more :intrigue: on the Shrine then the Extra Gauge shows.",
"As many or more corpses as the Extra Gauge shows.",
"assassination",
"Assassination",
"At least 1 :intrigue: on the shrine: Increase Extra Gauge by 4.",
"At least 1 :intrigue:, 1 :goodwill:, and 1 :paranoia: are placed on the character whose original role is a :person:",
"At least 2 :intrigue: on the City",
"At least 5 characters with :intrigue: on them.",
"At least three other characters with the same sex as :fanatic: died",
"At least two :intrigue: on the shrine.",
"At the end of the Day the Protagonists die. This happens after everything else. No more loops can be played. Go to Final Guess.",
"At the end of the day, if there are 3 or more total counters on this character, he dies.",
"At the end of the last Day, if there are 1 or fewer total counters on the Watcher, you may kill the Protagonists.",
"At the end of the loop, the Protagonists get to know the first subplot.",
"At the start of a loop, place either a :paranoia: counter, a :goodwill: counter or an :intrigue: counter on this character.",
"At the start of each loop, place an :intrigue: on the Shrine.",
"At the start of each loop, set the Extra Gauge to 0. Indicate World, even: Light World, odd: Dark World.",
"At the start of the day, if this character is dead, place ':partTimerAlternate:' in the City.",
"At the start of the first day, the Leader may place 2 :goodwill: on any one character of his choice.",
"Attach a Curse on the culprit.",
"augur",
"Augur",
"automaton",
"Automaton",
"Awakened Curse",
"awakenedCurse",
"barricade",
"Barricade",
"Base",
"Basic Tragedy",
"basicTragedy",
"Behind the Scenes",
"behindScenes",
"Bestial Murder",
"bestialMurder",
"BGG page.",
"Black Cat",
"blackCat",
"blackSchool",
"blasphemy",
"Blasphemy",
"Blasphemy	Place 1 :paranoia: and 1 :intrigue: on any corpse.",
"Bloody Rites",
"bloodyRites",
"Bomb Threat",
"bombThreat",
"boss",
"Boss",
"Boundary Between Life and Death",
"boundaryBetweenLifeDeath",
"boy",
"Boy",
"Boy Student",
"boyStudent",
"brain",
"Brain",
"brainwashing",
"Brainwashing",
"breakthrough",
"Breakthrough",
"But I had problems getting notifications from BGG, so Github is preferred.",
"Butterfly Effect",
"butterflyEffect",
"by",
"By Box",
"By Tragedy set",
"Card resolve",
"Cast",
"Change an :intrigue: conuter on any other character in this location to a :goodwill: counter.",
"Change of Future",
"Change of Heart",
"Change role to :serialKiller:s.",
"changeOfFuture",
"Changes to Starting Action Cards",
"Character",
"Character becomes the role \":creature:.\"",
"Character Cards",
"Character gains an additional role of \":serialKiller:.\"",
"Character is dead & At least 2 :intrigue: on this corpse",
"Character not found",
"Characters",
"Choir to the Outer God",
"choirOuterGod",
"Choose a Character in this Location, then choose a Character in another Location (The target Location must be legal for that Character). Switch their places. Once per Loop",
"Choose any character in this location and kill it.",
"Choose any other card in this location. If it is a corpse, it will be revived, If it is a character, it will be killed.",
"Choose any other character. For the remainder of the Loop, she also serves that character.",
"Choose one: 1. Remove up to 2 (cumulative total) :goodwill: counters from characters in the same Location as the Culprit. 2. Place up to 2 (cumulative total) :goodwill: counters on characters in the same Location as the Culprit.",
"Chose one of those. Plac any Extra Card on that character.",
"Chose one of those. Plac any Extra Card on that character. Character(s) with an Extra card has their role changed into a :keyPerson:.",
"Circle of Friends",
"circleFriends",
"City",
"Class Rep",
"classRep",
"Clicking on a missing Translation will open the translation editor.",
"Close",
"Closed Circle",
"closedCircle",
"closedDoor",
"comesInLater",
"Compakt View",
"confession",
"Confession",
"conspiracies",
"Conspiracies",
"Conspiracy Theorist",
"conspiracyTheorist",
"construct",
"Construct",
"Contract Killer",
"contractKiller",
"copycat",
"Copycat",
"Cosmic Evil",
"Cosmic Mythology",
"cosmicMythology",
"coward",
"Coward",
"creature",
"Creature",
"Crime of Passion",
"crimePassion",
"crimePassionSupernatural",
"Crossing World Lines",
"crossingWorldLines",
"crusader",
"Crusader",
"Culprit",
"Culprit is dead",
"Culprit must have at least 1+ :goodwill:.",
"Culprit's starting Location does not have 2+ :intrigue:",
"Culprit's starting Location has 2+ :intrigue:",
"Cult Member",
"cultist",
"Cultist",
"cultMember",
"curmudgeon",
"Curmudgeon",
"curse",
"Curse",
"Curse cards",
"Curse God",
"cursedDoll",
"cursedLand",
"curseGod",
"Dance of Fools",
"Dance Party of the Dead",
"danceFools",
"dancePartyDead",
"Dark Lesson",
"Dark Rumor",
"darkLesson",
"darkRumor",
"Day",
"Day 2 onward: At the start of each day, move to the next clockwise Location.",
"Day End",
"Day end on the fifth day",
"Day Start",
"Days per Loop",
"Deep One",
"deepHole",
"deepOne",
"default",
"Delayed Loss condition: Protagonists Death",
"Demonic Portal",
"demonicPortal",
"demonsScript",
"description",
"Description",
"Details",
"devilsHand",
"devilsWill",
"Diagonal Destruction",
"Diagonal Destruction 2",
"Diagonal Destruction 3",
"Dice of the Gods",
"diceOfGods",
"difficulty",
"Dimensional Distortion",
"Dimensional Fracture",
"Dimensional Merger",
"Dimensional Perversion",
"dimensionalDistortion",
"dimensionalFracture",
"dimensionalMerger",
"dimensionalPerversion",
"discovery",
"Discovery",
"distortion",
"Distortion",
"doctor",
"Doctor",
"Dose not Trigger Incident Effects",
"Dose not trigger incidents.",
"doseNotTriggerIncidentEffect",
"Drifting to Another World",
"driftingToAnotherWorld",
"dropStrychnine",
"Druing this loop, the original main plot is replaced by the \"extra\" main plot.",
"Dual Roles",
"During \"removal and placment of counters\" set the Extra Gauge to 0. For each Incident that occurse, increase the Extra Gauge by 1. This is done regardless of whether the Event itself has any effect or not.",
"During script creation, this character cannot be given a Role with :goodwill: Refusel.",
"During the \"removal and placement of counters\" step during Loop start also remove all Extra cards. Then, place the cards according to plot rules (if applicable).",
"Each turn, the Leader may move 1 counter on this character to another character at this location. If this character has :goodwill: Refusel, the Mastermind must also do this during the Mastermind's ability step.",
"edition",
"effect",
"Effect",
"Ego Wave",
"egoWave",
"Either kill another charcter in the same location as the culprit, or place an :intrigue: on the culprit’s location.",
"enchanter",
"Enchanter",
"Enters game on predefined loop",
"enters on day",
"enters on loop",
"Enters Play",
"Evangelium of the Dead",
"evangeliumDead",
"Every :inrigue: on locations counts as a corpse with the role :person:. If such a corpse is revived by the power of the :alien:, it is simply removed from the board.",
"Every location contains a :facsimile:.",
"Everyone in the City dies.",
"everyone in the diagonally opposite location dies",
"Everyone in the diagonally opposite location dies and protagonists lose",
"Everyone in the diagonally opposite location of the culprit dies",
"Everyone in the Hospital dies.",
"Everyone in the School dies.",
"Evil Contamination",
"evilContamination",
"executioner",
"Expanding Urban Legend",
"expandingUrbanLegend",
"exposure",
"Exposure",
"Extra Cads",
"Extra cards are treated as Curse cards. They can be placed on a location or be attached to characters and corpses. At the end of Day, before everything else, each curse is handeld. On a location the mastermind attaches a curse to any character in that location. Characters may have more than one curse. Characters with curses are killed (at the same time so a character that got a curse this step is not killed.) and the curse moves to the location. At the end of each loop, all Curses are removed.",
"Extra Gauge",
"Extra Gauge Effect",
"Extra Gauge Increase factors",
"Extra Gauge: Mythos knowlege",
"Extra Gauge: Number of Incidents",
"Extra Plot",
"Extra Rules",
"extraRules",
"faceless",
"Faceless",
"facelessGod",
"facsimile",
"Facsimile",
"factor",
"Factor",
"Fairy-Tale Murderer",
"fairyTaleMurderer",
"Fake Incident",
"faked",
"Faked",
"Faked Suicide",
"fakedSuicide",
"fakeIncident",
"Fan",
"fanatic",
"Fanatic",
"Fanatic’s Sacrifices",
"fanaticSacrifices",
"Faraway Murder",
"farawayMurder",
"Fatal Attraction",
"fatalAttraction",
"Fated Connections",
"fatedConnections",
"Feedback",
"Feedback (in English) is appriciated on",
"Final Guess",
"finalPlan",
"Fire and Brimstone",
"Fire of Demise",
"fireBrimstone",
"fireDemise",
"First Day",
"First Steps",
"firstSteps",
"fool",
"Fool",
"For each other character in cluprit’s location, pick any other location and move the character there.",
"For your Language there are missing translations, if you have time and fun you can help and add some localisations using the below. And post them on Github.",
"forbiddenFuture",
"forbiddenLocation",
"Forensic Specialist",
"forensicSpecialist",
"Foul Evil",
"foulEvil",
"Fountain of Filth",
"fountainFilth",
"fragment",
"Fragment",
"friction",
"Friction",
"friend",
"Friend",
"Full Moon Night",
"fullMoonNight",
"Gear Sample",
"ghost",
"Ghost",
"Ghost (Haunted Stage)",
"GhostHaunted",
"Giant Time Bomb",
"Giant Time Bomb Again",
"Giant Time Bomb Yet Again",
"giantTimeBomb",
"giantTimeBombAgain",
"giantTimeBombYetAgain",
"girl",
"Girl",
"Girl Student",
"girlStudent",
"Godly Being",
"godlyBeing",
"Goodwill & Wrarp",
"Goodwill ablility step",
"Goodwill Outburst",
"Goodwill Refusel",
"goodwillOutburst",
"goodwillRank",
"goodwillRefusel",
"gossip",
"Gossip",
"gossiper",
"Gossiper",
"Grave Robbing",
"graveRobbing",
"greatRace",
"Haunted City",
"Haunted Stage",
"hauntedCity",
"hauntedStage",
"Heart-Pounding Time Bomb",
"heartPoundingTimeBomb",
"Heavy Lovers",
"heavyLovers",
"henchman",
"Henchman",
"Here are some additonal interesting links related to Tragedy Looper.",
"Here you will find a list of scripts. Use one of them, or create your own.",
"Hero A",
"Hero B",
"Hero C",
"hiddenFreak",
"hideousScript",
"hider",
"Hider",
"Highlight missing translations",
"Highlights text that has no translation for your language.",
"Hints for the Mastermind",
"Home",
"horror",
"Horror",
"Hospital",
"Hospital Incident",
"hospitalIncident",
"Hound Dog Scent",
"houndDogScent",
"Howling in the Moonlit Night",
"howlingMoonlitNight",
"Human Doll",
"humanDoll",
"Hundred Demons Night",
"hundredDemonsNight",
"Hysteria Virus",
"hysteriaVirus",
"I am a Master Detective",
"I Am the True Detective!",
"Icon Set",
"id",
"If 3 or more people die in this (a single) incident, the protagonists are killed.",
"If any of the :cultMember:s have no :goodwill:",
"If at least 1 :intrigue: on the Culprit",
"If half or more of the characters in this location are :facsimile:s",
"If Last Will or The Executioner have triggered in this Loop.",
"If the :keyPerson: kills someone, the Protagonists lose.",
"If the :slayer: is alone with the :creature:, the :creature: dies.",
"If the Extra Gauge is 1 or higher",
"If the Extra Gauge is 2 or higher",
"If the Extra Gauge is 3 or higher",
"If the Extra Gauge was 3 or more at the end of the previous loop",
"If the players are in the Dark World and there is 1 or more :intrigue: counter on the culprit’s starting location",
"If the players are in the Light World",
"If the players are in the Light World and if this is the first time this game that this Incident triggered.",
"If there are 2 or fewer kinds of counters on this character",
"If there are 2+ :intrigue: on the :keyPerson:",
"If there are 3 or more :intrigue: counters on all corpses combined after using this roles other ability.",
"If there are 3 or more corpses of the opposite sex in this location",
"If there are 3 or more kinds of counters on the culprit",
"If there are at least 2 :intrigue: in this location, and at least 1 :paranoia: on this card",
"If there are at least 2 :intrigue: in this location: Switch the world.",
"If there are at least 2 corpses in this character’s starting location.",
"If there are two or more kinds of counters on this character",
"If there is a location where there are more :zombie:s than non-:zombie:s, kill one character in that location, then increase the Extra Gauge by 1 (reminder: a corpse is no longer considered as a character).",
"If there is a location where there are more :zombies: than non-:zombies:, kill one character in that location (reminder: a corpse is no longer considered as a character).",
"If there is at least 2 :intrigue: on the culprit's location.",
"If there is two :intrigue: on the :madGenius:'s starting location and the :madGenius: is alive and not at that location.",
"If this character gains :supernaturalTag: his :goodwill: abilities are automatically refused.",
"If this character has at least 1 :intrigue: at Loop End, the tragedy side wins.",
"If this Character is an Incident Culprit, you may treat him as if he is in the next clockwise Location.",
"If this character is dead",
"If this character is the culprit of an Incident that resolves, its effects resolve twice.",
"If this character was alive and had 2 or more :goodwill: at the end of the previous loop",
"If this character was dead at the end of the previous loop",
"If translations exist, you'll find localized character cards by following this link.",
"If you find bugs or have suggestions, please let me know.",
"If you translate the text it will be used in this Browser.",
"If you translated something, please open an issue on Github and post the exported text, or submit a pull request.",
"If you're the Mastermind, [choose a script (SPOILER!!)](/script).",
"Ignore :goodwill: +1 and :goodwill: +2 Actions set on this character.",
"Ignore \"Forbid Movement\" Actions on this Character.",
"Ignore all :intrigue: Counters placed on the Location where this Character is, as well as on any other Characters in the same Location.",
"Ignore Forbid :goodwill: cards played on this character.",
"Ignore Forbid :goodwill: for this character.",
"Ignore Forbid :goodwill: on this character.",
"illusion",
"Illusion",
"immortal",
"Immortal",
"immortalRole",
"Immune to Goodwill Refusal",
"immuneToGoodwillRefusel",
"In addition to effects that trigger a Warp, a Warp is automatically triggered after each time any player, Protagonist or Mastermind, uses a 1x∞ :goodwill: ability. (Thematically these abilities have a powerful effect on the world, causing instability in the timeline.)",
"In Normal world",
"In the same location as a dead character.",
"In the same Location as an Incident triggered by a living Character who has 1+ :despair:",
"Incident",
"Incident not found",
"Incident step",
"Incident trigger",
"incidents",
"Incidents",
"Incidents of which this character is the culprit, change their effect into \"no effect\". (rule-wise they occur)",
"Increase Extra Gauge by X. X is equal to the number of :intrigue: on the City. (Max 3).",
"Increase it by 1.",
"Increase the Extra Gauge 1 step.",
"Increase the Extra Gauge by 1 and revive the culprit.",
"Increase the Extra Gauge by 2.",
"Increasing Unease",
"increasingUnease",
"Independent",
"Indicate World, 1: Normal and intial World, 2: Abnormal World.",
"indoctrination",
"Indoctrination",
"Infestation",
"infestation",
"infestationSupernatural",
"influencer",
"Influencer",
"informer",
"Informer",
"Insane Murder",
"insaneMurder",
"Into Nothingness",
"intoNothingness",
"invader",
"Invader",
"Is in Tragedy",
"Is not in Tragedy",
"Isolated Institution Psycho",
"isolatedInstitutionPsycho",
"Japanese storefront.",
"Jekyll and Hyde",
"jekyllHyde",
"journalist",
"Journalist",
"Keeper of Mythology",
"keeperMythology",
"Key",
"Key Person",
"keyGirl",
"keyPerson",
"Kill all Characters in all Locations except the Shrine.",
"Kill all characters in the culprits location.",
"Kill another Character in the Culprit's location.",
"Kill another Character in this location that has 2 or more :intrigue:.",
"Kill any character in the same location. If that character is not :supernaturalTag:, the Protagonists lose.",
"Kill any one character (including culprit) in the same location as the culprit.",
"Kill any other character in this location or on the diagonally opposite location. When determining whether this incident occurs or not, count :intrigue: instead of :paranoia:.",
"Kill any other character in this location. If there is no other character, kill this character.",
"Kill one character in same location.",
"Kill one Character in the same Location (Once per Loop).",
"Kill one character in the same location as :overlord:.",
"Kill one character of the opposite sex in this location who has at least 1 :paranoia: and 1 :intrigue:.",
"Kill that Character. You may also place up to 1 :intrigue: and 1 :paranoia: counter each on yourself.",
"Kill the :keyPerson:",
"Kill the Protagonist.",
"killer",
"Killer",
"kingYellow",
"Language",
"Last Day",
"Last Liar",
"Last Will",
"lastLiar",
"lastMiracle",
"lastWill",
"Leader gets one (1×∞) card back.",
"Leader names the title of any Subplot. Then, the Mastermind must name the title of any other active subplot.",
"Left Behind",
"leftBehind",
"Light of the Avenger",
"lightAvenger",
"lightHope",
"Little Sister",
"littleSister",
"littleSisterKeyword",
"local script",
"location",
"Loop 2 or later: Reveal the name of all characters with the same Role as :copycat:. This cannot be refused by :goodwill: Refusel.",
"Loop End",
"Loop ends",
"Loop Start",
"Loss condition: Tragedy",
"Lost Heart",
"lostHeart",
"Love-Hate Spiral",
"loveAffair",
"Loved One",
"lovedOne",
"loveHateSpiral",
"lover",
"Lover",
"lullaby",
"Lullaby",
"lunatic",
"Lunatic",
"Mad Genius",
"madGenius",
"Madness (4)",
"Madness [Extra Gauge 4 or more]: Decrease the Extra Gauge by 4 and kill the Protagonists at the end of the day.",
"magician",
"Magician",
"Main Plot",
"Main Plots",
"mainPlots",
"Make sure to set the page size to A4 landscape, set the margins to 0 and **disable** double sided printing.",
"Make sure to set the page size to A4 landscape, set the margins to 0 and **enable** double sided printing (short edge).",
"Male Confrontation",
"maleConfrontation",
"man",
"Man",
"Mandatory",
"mandatory",
"Mandatory Loss condition: Protagonists Death",
"manifestation",
"Manifestation",
"Many abilities and effects in this Set “trigger a Warp”. If one or more Warps are triggered on a given day, at the end of that day, increase the Extra Gauge by 1. This increase happens before any other effects during the Day end phase, including Mandatory effects. Note that even if multiple Warps are triggered on the same day, the Gauge still only increases by 1. The Mastermind is not obliged to announce when a Warp is triggered. As such, if a Warp is triggered, but the loop ends before the end of that day, they can hide the fact that it triggered at all.",
"marionette",
"Marionette",
"marionetteAHR",
"Mass Hysteria",
"Mass Suicide",
"massHysteria",
"massSuicide",
"masterDetective",
"Mastermind Ability",
"Mastermind able to use the character’s :goodwill: abilities whose role has :goodwill: Outburst.",
"Mastermind Action step",
"Mastermind Aid",
"Mastermind chooses start location each loop",
"max",
"Max Crazy Gauge",
"maxCrazyGauge",
"maximumRoles",
"May be regarded as in his turf.",
"Metamorphosis",
"Metaworld Denizen",
"metaworldDenizen",
"Midnight Circle",
"Midnight Zone",
"midnightZone",
"mimic",
"Mimic",
"Missing Person",
"Missing Translation",
"Missing Translations",
"missingHighlight",
"missingPerson",
"mob",
"Mob",
"Mob Incidents",
"monster",
"Monster",
"Monster Intrigue",
"Monster Liberation",
"monsterInsideMe",
"monsterIntrigue",
"monsterLiberation",
"Mood Maker",
"moodMaker",
"Moonlight Beast",
"moonlightBeast",
"Moonside City",
"moonsideCity",
"Mother Goose Mystery",
"motherGooseMystery",
"Move 1 counter between two other characters at this character’s location.",
"Move a Character from his/her location to another location. Move a second Character from his/her location to another location.",
"Move any card in this location to any location.",
"Move any card on the culprit’s location to any other location.",
"Move any character from this location to any other location.",
"Move any character in the culprit’s location to any location. If the character actually changed location, that character cannot be moved the next day.",
"Move any one counter between any two other characters in this location.",
"Move culprit to any Location. Put 1 :intrigue: on that Location.",
"Move the Culprit to any Location.",
"Move this character t an adjacent location",
"Move this Character to any Location, and revive one corpse in that area. Put “X” :goodwill: on the revived Character.",
"Movement actions do not affect this Character.",
"murder",
"Murder",
"Murder for Hire",
"Murder Plan",
"murderHire",
"murderPlan",
"murkDespair",
"Mystery Boy",
"Mystery Circle",
"mysteryBoy",
"mysteryCircle",
"mythomaniacSecret",
"name",
"neurotic",
"Neurotic",
"Night Mist Nightmare",
"Night of Madness",
"Night: Day End",
"Night: Loop End",
"nightMadness",
"nightmare",
"Nightmare",
"Nightmare (Haunted Stage)",
"nightmareHaunted",
"nightMistNightmare",
"ninja",
"Ninja",
"No :facsimile: are alive.",
"No action cards can be placed on this characte. All cards palced on this location are also applied to this character.",
"No Culprit",
"No incident",
"No Set",
"nobleBloodline",
"Noisy Classmates",
"noisyClassmates",
"nonSelectableCharacter",
"Not everything is cleand up yet.",
"not in plots",
"Not yet completed. But here is the current version of the Rei Board.",
"number",
"Number of Characters not in Plot roles",
"numberOfMainPlots",
"numberOfSubPlots",
"nurse",
"Nurse",
"obstinate",
"Obstinate",
"Office Worker",
"officeWorker",
"On character death",
"On Character Death",
"On Role reveal",
"Once per {type}",
"One (1) other character in culprit’s Location dies",
"One character at this character’s location dies.",
"One character with at least 2 :intrigue: dies.",
"One charcters in the same location dies.",
"One or more Location Curses can’t be attached to characters",
"One other character at the culprit’s location dies, if possible. When determining if this Incident triggers, treat the culprit’s :paranoia: Limit as 1 lower.",
"One other character in the culprit’s location dies. The same character may be the culprit of several Serial Murder Incidents.",
"OnesFromGrave",
"Only at",
"Only show Missing",
"optional",
"Optional",
"Optional Loss condition: Protagonists Death",
"Optional Loss condition: Tragedy",
"Options",
"or",
"Or change the the card layout settings above.",
"Otherwise, ask your Mastermind to choose a script and send you the link.",
"Over all Roles",
"overlord",
"Overlord",
"Own Scripts",
"Palce 1 :paranoia: on any character in this location, or any character in the :ghost:’s starting location.",
"Panic and Obsession",
"panicObsession",
"Parallel World War",
"parallelWorldWar",
"paranoia",
"Paranoia Limit",
"Paranoia Virus",
"paranoiac",
"Paranoiac",
"paranoiaLimit",
"paranoiaVirus",
"Part-Timer",
"Part-Timer(?)",
"partially",
"parting",
"Parting",
"partTimer",
"partTimerAlternate",
"passive",
"Passive",
"patient",
"Patient",
"People Who Don’t Listen",
"People Who Saw",
"peopleDontListen",
"peopleWhoSaw",
"person",
"Person",
"Phantasmal Incident",
"phantasmalIncident",
"Pick a :student: in this location, and add or remove a :paranoia: from that student.",
"Pick a neigboring location, and move the charcter there.",
"Pied Piper",
"piedPiper",
"Place +1 :intrigue: counter on any Location or Character (Once per Loop).",
"Place +1 :paranoia: on a Character in School.",
"Place 1 :despair: counter on a character at this character’s location, and you may trigger a Warp.",
"Place 1 :goodwill: counter on one other character in the same Location.",
"Place 1 :hope: counter on each other character at this character’s location.",
"Place 1 :hope: or :despair: counter on any character at this location. If this character has :goodwill: Refusel and at least 1 :goodwill: counter, the Mastermind may use this ability as their own",
"Place 1 :intrigue: counter on a character at the culprit’s location, then move the culprit to any location.",
"Place 1 :intrigue: or :paranoia: on one corpse in this location.",
"Place 1 :intrigue: or 1 :paranoia: on this Character.",
"Place 1 :paranoia: and 1 :goodwill: on each Character who shares this Character's starting Location.",
"Place 1 :paranoia: on each Character who shares this Character's starting Location.",
"Place 1 :paranoia: or :goodwill: counter on a character at this character’s location.",
"Place 1 Despair counter on any character.",
"Place 2 :intrigue: on that Location.",
"Place 2 :intrigue: on the culprit’s location.",
"Place 2 :intrigue: on the Shrine.",
"Place 2 :paranoia: on all characters who had :goodwill: last loop.",
"Place 2 :paranoia: on another character in this location.",
"Place 2 :paranoia: on any character, then 1 :intrigue: on any other character.",
"Place 2 :paranoia: on any one character, and an :intrigue: on any location.",
"Place 2 Paranoia on a character of your choice, and 2 :goodwill: on another character of your choice.",
"Place a :goodwill: on an other Character who is at their :paranoia: Limit.",
"Place a Curse on the :ghost:’s starting location",
"Place a Curse on the :witch:’s startiong location.",
"Place a curse on the culprit’s location.",
"Place an :intrigue: on one location.",
"Place two :intrigue: on the Shrine. Move a Character from the Shrine to the School, if possible.",
"placeProtect",
"Placing Cards",
"plaguebringer",
"Players are in the Light world",
"Please consider contributing to the translations and submit it to",
"plot",
"plot duplicate",
"Plot not found",
"plotLessRole",
"poisoner",
"Poisoner",
"Police Officer",
"policeOfficer",
"poltergeist",
"Poltergeist",
"Pop Idol",
"popIdol",
"portent",
"Portent",
"possessed",
"Possessed",
"potentate",
"Potentate",
"Prepare the EX Gauge, starting at 0. From that Day onward, the EX Gauge increases by 1 at each Day End phase. When it reaches 3, the :goodwill: counters on all Characters decreases by 2. When a :goodwill: counter is placed on the Culprit, the EX Counter resets to 0.",
"prerequisite",
"Prerequisite",
"Prerequiste",
"Prime Evil",
"primeEvil",
"primeEvilPlot",
"Print to PDF is recommended",
"Print View",
"Printing this page will only Print the board in 57.57cm × 40.57cm.",
"Private Investigator",
"privateInvestigator",
"Promise of a Smile",
"promiseSmile",
"Promo",
"prophet",
"Prophet",
"proselytizing",
"Proselytizing",
"Protagonist C wins.",
"Protagonist can place cards on the corpse, and use its :goodwill: abilities. However, there is a penalty for corpses that do not have After Death activity. Set Extra Gauge at 0 at the start of the game. Extra Gauge doesn’t reset after loop end.",
"Protagonist Leader may request to switch the world during the Day Start",
"Public Meltdown",
"publicMeltdown",
"Puppeted",
"Puppeted :goodwill: Refusel",
"Puppeted :goodwill: Refusel is a new form of :goodwill: Refusel. In addition to providing the basic effect of :goodwill: Refusel, the Mastermind may use the :goodwill: abilities of a character with Puppeted :goodwill: Refusel during the Mastermind abilities phase, provided that there are sufficient counters on that character. When they do, they must announce what ability is being used, and any targets that ability has, if applicable.",
"Puppeteer’s Strings",
"puppeteersStrings",
"Put 1 :goodwill:, or 1 :paranoia:, or 1 :intrigue: on any character in this location.",
"Put an Extra card on the culprit’s location. Thereafter, the card is treated as a character whose title is Demon Beast and gains Nightmare’s role.",
"Put an Extra marker on another character in same location. Remove that marker to prevent that character from dying.",
"Put any counter on any character in culprit’s Location.",
"quiltIncidents",
"realMonster",
"Refuse Goodwill Ability",
"Rei",
"Rei Board",
"relocation",
"Relocation",
"Reminiscence of the Forefathers (2)",
"Remote Bombing",
"remoteBombing",
"Remove 1 :goodwill: counter on one other character in the same Location.",
"Remove 1 :intrigue: in this Location or on any character in this Location",
"Remove 1 :paranoia: counter from any other character in this location.",
"Remove 2 :goodwill: (or 1 if they only have that) from a character, and then add 2 :goodwill: to another character.",
"Remove all :goodwill: counters from one Character in the same Location as the Culprit.",
"Remove all :goodwill: from a Character and replace with a mix of :paranoia: or :intrigue: that equals the removed :goodwill:.",
"Remove all :paranoia: counters from its corpse.",
"Remove all counters from this character. Then, if you use the Extra gauge, increase or decrease this gauge.",
"Remove one :intrigue: Counter from a Character in the same Location.",
"Remove thsi character from the board for the rest of the loop.",
"Rendering",
"Repeated Culprit",
"repeatedCulprit",
"Repeating Nightmare",
"repeatingNightmare",
"resistance",
"Resolve either a :serialMurder: or a :missingPerson: Incident. Check :intrigue: instead of :paranoia: conters to trigger the Incident.",
"Resolve the effect of Crime of Passion, Dimensional Perversion, or Left Behind. When determining if this Incident triggers, refer to the number of :intrigue: counters on the culprit instead of the original type of counter.",
"Resolving Cards",
"restrictedToLocation",
"Reveal culprit for 1 incident.",
"Reveal culprit for former incident.",
"Reveal its role.",
"Reveal own role.",
"Reveal role of character in his turf.",
"Reveal role of character in same location",
"Reveal the culprit and the culprit’s role.",
"Reveal the culprit’s locationto. For 3 days, including the day the incident occurred, any movement to or from that location is nullified.",
"Reveal the role of another character who is at their :paranoia: Limit in this location.",
"Reveal the role of any one corpse.",
"Reveal the role of one :student: in this location.",
"Reveal the role of the Culprit.",
"Reveal this Character's Role.",
"Reveal this character's Role. Place 2 :goodwill: counters on any character at this location.",
"Revive one corpse in same location.",
"revoke location restirction for :patient:.",
"Rich Man’s Daughter",
"richStudent",
"Ritual Sacrifice",
"ritualSacrifice",
"Role",
"Role / Plot / Incident",
"roles",
"Roles",
"Route Branching",
"routeBranching",
"rules",
"Rules",
"Sacred Tree",
"sacredTree",
"sacredWordsDagon",
"sacrifice",
"Sacrifice",
"sacrificeHaunted",
"Sacrilegious Murder",
"sacrilegiousMurder",
"School",
"School Shooting",
"schoolShooting",
"scientist",
"Scientist",
"Script creation",
"Script Creation: Specify a number “X” to be the :paranoia: Limit. Treat this character’s :paranoia: Limit as 0 for anything besides an Incident.",
"Script Creation: This Character must copy the role of another Character in the script (max amount ignored).",
"Script writer may choose 0 or 1 or 2 :curmudgeon:s.",
"Scripts",
"scriptSpecified",
"Seal of the Evil Spirit",
"sealedConclusion",
"sealedItem",
"sealEvilSpirit",
"Secret Record",
"secretkeeper",
"Secretkeeper",
"secretRecord",
"Sect Founder",
"sectFounder",
"seed",
"seeder",
"Seeder",
"Seeping Daylight",
"seepingDaylight",
"Select a character",
"Select a plot",
"Select Tragedy Sets…",
"sennin",
"Sennin",
"Serial Killer",
"Serial Murder",
"serialKiller",
"serialMurder",
"servant",
"Servant",
"Sessions are hosted semi-regularly here.",
"Set an Extra Card on the culprit. The Protagonists may not play any cards on character(s) with an Extra Card.",
"sevenSchoolMysteries",
"shadow",
"Shadow",
"Shadow Demon King",
"Shadow of the Ripper",
"shadowDemonKing",
"shadowRipper",
"shifter",
"Shifter",
"Shorten Urls",
"Show less",
"Show more",
"Show-Off",
"showInGmScreen",
"showOff",
"Showtime of Death",
"showtimeDeath",
"Shrine",
"Shrine Maiden",
"shrineMaiden",
"Sign with me!",
"signWithMe",
"silverBullet",
"Since this board will probably never be released in english, not to mention any other language. This is an atempt to have a localized version.",
"singularity",
"slayer",
"Slayer",
"Small Force",
"smallForce",
"Smell of Gunpowder",
"smellGunpowder",
"Social Media Paranoia",
"socialMediaParanoia",
"soldier",
"Soldier",
"Some plots have dual roles. These roles are always on the same character. The first role is in the Light World, and the second role is in the Dark World. The character’s role is determined by the world they are in.",
"someoneInvites",
"Source",
"Special Rule",
"Special Rules",
"Specify a number for X to be the :paranoia: Limit. When checking the :paranoia: Limit for anything besides an Incident, treat this character's :paranoia: Limit as 0.",
"Spell of Sympathy (1)",
"spellcaster",
"Spellcaster",
"Spore Pod",
"sporePod",
"spreading",
"Spreading",
"spreadingInfection",
"startLocation",
"Story",
"storyteller",
"Storyteller",
"strangeStory",
"student",
"Student",
"Sub Heroine",
"Sub Plot",
"Sub Plots",
"subHeroine",
"Submit",
"subPlots",
"suicide",
"Suicide",
"Suicide Cult",
"suicideCult",
"Supernatural",
"supernatural",
"supernaturalTag",
"supplicant",
"Supplicant",
"suspiciousLetter",
"Switch the world to Abnormal World.",
"Switch world to Normal world. The world cannot be switched for the remainder of this loop",
"Switching the world is prohibited except for this plot rule ability.",
"Tablet View",
"Tabletop Simulator Mod",
"Tag not found",
"tags",
"Tags",
"teacher",
"Teacher",
"terrorism",
"Terrorism",
"text",
"That character dies.",
"That incident does not trigger, regardless of the number of :paranoia: conters on the culprit.",
"That way everyone can benefit from your translation.",
"The :agent: must be the World Convergent culprit.",
"The :creature: has at least 5 :intrigue:",
"The :facsimile: is in the same location as the :keyPerson:",
"The :facsimile: is Killed.",
"The :factor: is alive.",
"The :incident: always triggers, regardless of what other counters the Character has.",
"The :informer: must be included. The script writer then chooses one \"extra\" main plot.",
"The :keyPerson: does not have more than \"X\" :goodwill:. \"X\" is half the number of Days in one Loop, rounded down.",
"The :keyPerson: has at least 2 :intrigue: and is in this character‘s location",
"The :keyPerson: has at least 2 :intrigue: and is in this character’s location",
"The :keyPerson: must be a :girl:.",
"The :keyPerson:s role changes to :person:.",
"The :lovedOne: dies",
"The :lover: dies",
"The :ninja: (for this plot) must have the tag man.",
"The :ninja: (or its corpse) has at least 2 :intrigue: counters.",
"The :paranoiac: gains all the abilities of the :keyPerson:",
"The :servant: serves the :richStudent: and the :boss:. If one of them moves and she shares the location, the Leader moves her with one of them ignoring her own movement. If any onf them dies at her location, she dies instead.",
"The :supplicant: gainst :supernaturalTag: tag.",
"The :supplicant: has 1 :intrigue: and is in the same location as the :lover:",
"The Black School",
"The character gains :goodwill: Outburst and :marionette:’s ability.",
"The Character with the highest :goodwill: is killed. If no Character has the highest, this Incident doesn't trigger.",
"The Closed Door",
"The culprit dies.",
"The culprit dies. At the start of the next loop, the Protagonists add \"Hope +1\" to hand.",
"The Culprit is a :person: and the :prophet: is alive.",
"The Culprit is treated as if they are not in any Location, and cannot have Action cards placed on them.",
"The Culprit must have enough :goodwill: to use a :goodwill: Ability.",
"The Culprit must not have any :goodwill: on them when this Incident occurs.",
"The culprit of an incident that would trigger is in another location",
"The Culprit's role changes to Key Person for the rest of that Loop.",
"The current Day is a multiple of 3",
"The current English edition for sale.",
"The current world is Abnormal world and there are at least 2 :intrigue: on the :invader:‘s starting Location",
"The current world is Normal world and there are at least 2 :intrigue: on the :brain:‘s starting Location",
"The Cursed Doll",
"The Cursed Land",
"The Deep Hole",
"The Demon’s Script",
"The Devil’s Hand",
"The Devil’s Will",
"The Executioner",
"The Extra Gauge has increased at all this loop.",
"the Extra Gauge is 0, and the culprit is in this location",
"The Extra Gauge is 1 or above",
"The Extra Gauge is 1 or less",
"The Extra Gauge is 1 or lower.",
"the Extra Gauge is 2 or more",
"The Extra Gauge is 3 or more.",
"the Extra Gauge is on 2 or more",
"The Extra Gauge is on 2 or more.",
"The Extra Gauge is on 4 or more.",
"The Extra Gauge was 2 or less at the end of the previous loop",
"The Faceless God",
"The Far Side",
"The Final Plan",
"The Forbidden Future",
"The Great Race",
"The Hidden Freak",
"The incident happens at :paranoia: limit -1",
"The Incident triggers regardless of the number of :paranoia: counters on the culprit.",
"The Key Girl",
"The King in Yellow",
"The Last Miracle",
"The Leader chooses a character. Place 1 :Hope: counter on that character. When determining if this Incident triggers, refer to the number of :Goodwill: counters on the culprit instead of the original type of counter.",
"The Leader chooses a character. Place 1 Hope counter on that character.",
"The Leader chooses a location. All Characters from that Location Move to the Location clockwise from their current Location.",
"The leader chooses one character. That charcter is killed.",
"The Leader may resolve one incident in the Script, wit the :ai: as the culprit. (This is not considered triggering the event.)",
"The Light of Hope",
"The loop ends after this Incident step (resulting in a Protagonist victory unless any loss condition is fullifilled). This Incident dose not increase the Extra Gauge.",
"The loop ends immediately.",
"The loop is even numbered.",
"The loop is the final loop.",
"The Mastermind adds \":despair: +1\" to hand.",
"The Mastermind can only play 1 Action card on the following Day. At the end of that Day, or this Day if it's already the final Day, kill the Protagonists.",
"The Mastermind cannot place any Movement Actions on the :keyPerson:.",
"The Mastermind cannot place cards on this character.",
"The Mastermind cannot set an action card on this card.",
"The Mastermind may declare that “:enchanter:‘s abilities were used.” If you do, the next day Leader are prohibited from switching the world and setting action cards.",
"The Missing Highlight",
"The missing translation:",
"The Monster Inside Me",
"The Murk of Despair",
"The Mythomaniac's Secret",
"The Noble Bloodline",
"The number of corpses is 2 or less.",
"The number of surviving characters is 4 or less",
"The numbers of :goodwill: counter need to reach :paranoia: Limit to trigger the incident. Also sufficient numbers of :paranoia: needed to activate the character’s :goodwill: ability.",
"The One Who Invites",
"The Ones from the Grave",
"The Plaguebringer",
"The Protagonist Leader chooses any character and 1 :goodwill:, or 1 :paranoia:, or 1 :intrigue:. Put one chosen counter on that character. When determining whether this incident occurs or not, the culprit is regarded as having :paranoia: Limit -1.",
"The Protagonist Leader chooses one location or character, and removes 2 :intrigue: counters from there.",
"The Protagonist’s \"Forbid :intrigue:\" cards are no longer nullified if more then one of them are played in the same day.",
"The Protagonists add \":hope: +1\" to hand.",
"The Protagonists additionally each have a :paranoia: +2 (1x∞) card, and the Mastermind additionally has a :goodwill: +1 card. Furthermore, the Mastermind also adds a Despair +1 (1x∞) card to their hand for the first loop only. (On later loops, they only gain it if an effect allows them to do so.)",
"The Protagonists cannot die for the reminder of the loop.",
"The Protagonists will die after the day has ended.",
"The Real Monster",
"The Resistance",
"The roles of Characters with \"X\" or more :goodwill: are revealed. \"X\" is half the number of Days in one Loop, rounded down.",
"The Sacred Words of Dagon",
"The Sealed Conclusion",
"The Sealed Item",
"The Secretkeeper gains :Goodwill: Refusal. If there is no Secretkeeper during script creation, instead add an additional :killer:, :brain:, or :fragment: to the script. (It does not count as a Role specified by this Plot.)",
"The Seed",
"The Seven School Mysteries",
"The sex of this character is reversed.",
"The Silver Bullet",
"The Singularity",
"The Spreading Infection",
"The target of that ability dies.",
"The translation for this text is missing.",
"The World of Dollhouse",
"therapist",
"Therapist",
"There are 3 ore more :intrigue: on all corpses in total",
"There are 6 or less characters alive.",
"There are a total of 12 or more :paranoia: counters on the remaining charactrs.",
"There are at least 2 :intrigue: counters on the Shrine.",
"There are at least 3 :paranoia: on the :ghost:’s corpse.",
"There are at least 3 corpses on the location where 1 or more :intrigue: are placed.",
"There are more than X :intrigue: counters on the School, X is 1 less than the current loop number.",
"There are X or more corpses at the end of the loop, X is the current loop number, to a maximum of 3.",
"There is 2 or less :goodwill: on this character.",
"There is a Character of the same sex with 3+ :goodwill: in the same area.",
"There is any charcter with at least 2 :intrigue: Counters in this location",
"There is at least 2 :intrigue: on the City",
"There is at least 2 :intrigue: on the School",
"There is exactly 1 other (living) character in this location",
"There must be at least one :suicide: Incident",
"These Incidents do not specify a character as a culprit, but a location. If there are enough corpses (specified by the incident) on the specific location, the incident happens.",
"This card is a corpse",
"This character always triggers its Incidents (if alive), regardless of the amount of :paranoia: counters on it.",
"This character always triggers its incidents (if alive), regardless the amount of :paranoia: on it. After resolving the Incident, the Mastermind declared that “:animus: abilities were used.”.",
"This character can never be a culprit.",
"This Character can't die",
"This character cannot die.",
"This character cannot have the role :person:.",
"This character dies",
"This character dies and you trigger a warp.",
"This character dies.",
"This character does not appear on the board until the start of the day specified by the script.",
"This Character gains Mandatory :goodwill: Refusel.",
"This character gains the :conspiracyTheorist:‘s ability, but not its role.",
"This character gains the :keyPerson:’s ability, but not its role.",
"This Character gains the abilities of :conspiracyTheorist:, :brain:, and :serialKiller:.",
"This character gains the abilities of a :conspiracyTheorist:.",
"This character gains the abilities of a :deepOne:.",
"This character gets 1 :goodwill:.",
"This character gets 6 :paranoia:.",
"This character has 4 or more :paranoia:",
"This character has at least 1 :intrigue:",
"This character has at least 2 :intrigue: and at least 2 :paranoia:",
"This character has at least 3 :paranoia: and at least 1 :intrigue:.",
"This character has at least 4 :intrigue:",
"This character has died, or their Goodwill ability has been triggered.",
"This character has the same Role, and is the Culprit of the same Incident(s), as :partTimer:.",
"This character ignores its Role and is a :person: instead.",
"This character is dead",
"This character is dead.",
"This Character loses the :immortal: aspect.",
"This character must be the culprit of an Incident",
"This character must be the culprit of an incident.",
"This Character must be the Culprit of an Incident.",
"This character must be the culprit of an Incident.",
"This Character resolved an incident",
"This Character resolves an incident",
"This character's Goodwill ability has been triggered.",
"This Character‘s location restriction is removed",
"This character's Role has been revealed, and it's currently the 1st or 2nd Loop.",
"This charcter dies, and the Extra Gauge increases with 1 step.",
"this charcter has 2 or more :paranoia:",
"This charcter has more then 2 :paranoia:",
"This has no effect but the incident is triggered.",
"This is a community project, so it is not perfect.",
"This role has been revealed",
"This should list all texts and keywords used, but not yet translated into your language. However, it's not applied everywhere yet. The Player Aid should be completely set, but others are missing.",
"Those with Habits",
"thoseHabits",
"Threads of Fate",
"threadsFate",
"Through I may not have time to fix it. But I will be happy to integrate your contributions.",
"Through the Looking-Glass",
"throughLookingGlass",
"Tightrope Plan",
"tightropePlan",
"Time Traveler",
"Times per day",
"Times per loop",
"timesPerDay",
"timesPerGame",
"timesPerLoop",
"timeTraveler",
"timing",
"Timing",
"Touch optimized View",
"Tragedy",
"Tragedy Looper Deduction overview",
"Tragedy Looper Deduction Sheet Overview",
"Tragedys",
"Traitor(s) become normal Protagonists. If this is true at the end of the final Loop, this carries over to the Final Guess.",
"Transfer 1 :intrigue: from a character to the characers location or another character in the same location.",
"Transfer Student",
"Transfere 1 :intrigue: from a Character to that Character's location or another Character in the same location.",
"transferStudent",
"Translation",
"Translation Overview",
"Translations",
"tree",
"Tree",
"Tricky Twins",
"trickyTwins",
"Trigger a Warp.",
"troublemaker",
"Troublemaker",
"trueDetective",
"Turf",
"Twice per {type}",
"twilight",
"Twilight",
"twin",
"Twin",
"Twisted Threads of Time",
"Twisted Truth",
"twistedThreadsTime",
"twistedTruth",
"type",
"Type",
"Unanswered Heart",
"unansweredHeart",
"Unknown Factor X",
"unknownFactor",
"Unsafe Trigger",
"unsafeTrigger",
"unsettlingRumor",
"Unspeakable Horrors",
"unspeakableHorrors",
"uploader",
"Uploader",
"uproar",
"Uproar",
"Urls will be gZipped to shorten them and prevent to long urls.",
"Use a :goodwill: ability from an :adult: at this location, ignoring :goodwill: counters. It cannot be refused by :goodwill: Refusel, but counts towards that ability's 'Once per Loop' limit.",
"Use an Available (counter requirement on target Character met) Goodwill ability from another Character in the same location. This is regarded as the Mimic using the ability.",
"Use the **Print** button of your browser (default shortcut[[Ctrl]]+[[P]]) to print the cards.",
"vampire",
"Vampire",
"Vampire (Haunted Stage)",
"vampireHaunted",
"Victims",
"Victory Condition A: There are 5 or more Perished tokens.",
"Victory Condition B: There are 6 or more Acquainted tokens.",
"Victory Condition C: Immediately before the Final Guess, Protagonist C correctly identifies the culprit of each :incident:.",
"Victory Conditions",
"Visual Novel",
"visualNovel",
"Warping",
"watcher",
"Watcher",
"werewolf",
"Werewolf",
"Werewolf (Haunted Stage)",
"werewolfHaunted",
"When counting :intrigue: on a Location, count :hope: and :despair: on Characters in the same Location as :intrigue:.",
"When determinig whether this incident occours or not, count :intrigue: instead of :paranoia:. For the rest of the loop, if another Incident occours, the Protagonists are killed after the Incident step.",
"When determining if an Incident triggers, :goodwill: is counted instead of :paranoia:. When determining if a :goodwill: ability can be used, :paranoia: is counted instead of :goodwill:.",
"When determining wether an Incident triggers, to which this character is the culprit, all conters on this character conut as :paranoia: conuters.",
"When determining whether \":serialMurde:,\" or \":suicide:\" triggers, count :intrigue: counters also as :paranoia: counters.",
"When determining whether an Incident, for which this character is the culprit, will occour or not, also treat :intrigue: as :paranoia:.",
"When determining whether an Incident, for which this character is the culprit, will occur or not, this character is regarded as having :paranoia: Limit -1.",
"When determning whether an Incident triggers, the culprit is regarded as having 1 less than its printed :paranoia: limit.",
"When the first Incident of the Loop occurs, during that Day's End Phase, the Mastermind sets an EX Card on a boy or girl. If the :uploader: uses a mandatory Ability, it is treated as being in the location of the EX Card.",
"When the Loop ends—if the :keyPerson: is not in the initial starting location of the :subHeroine:, the :keyPerson: dies.",
"When the Protagonist Leader declares to switch the world, you may refuse it",
"When this character dies: Put 1 :intrigue: in this location.",
"When this character triggers an Incident, it is considered as being on the diagonally opposit location.",
"When this character’s :goodwill: ability is used, reveal this role after resolution. Then, the leader may increase the Extra Gauge one step.",
"When this charcter dies, reveal the role and increast the Extra Gauge 1 step.",
"When this role is to be reveald",
"When you have stored local translations, this will allow you to edit it with a click.",
"While in the Dark World and characters whose original Roles were either :person: or :fragment: and have 2 or more kinds of counters on them",
"Whispers from the Deep",
"whispersFromDeep",
"Wiki",
"wildcard",
"Wildcard",
"witch",
"Witch",
"Witch’s Curse",
"Witches' Tea Time",
"witchesTeaTime",
"witchsCurse",
"witness",
"Witness",
"wizard",
"Wizard",
"woman",
"Woman",
"world",
"World Convergence",
"World End",
"World of Rebellion",
"World Selection",
"World Switch",
"worldConvergence",
"worldDollhouse",
"worldEnd",
"worldRebellion",
"Worshippers of the Apocalypse",
"worshippersApocalypse",
"Writer",
"You can change if text or icons should be used, and what nomiclatur should be used.",
"You may ignore all Forbid :intrigue: effects on this location and on all characters in this location.",
"You may kill all characters and the Protagonists.",
"You may kill one Character in the same location who has 1+ :intrigue: Counter(s) on them, unless a :slayer: is in the same Location.",
"You may kill one character who is in this location.",
"You may kill the :keyPerson:.",
"You may move one :zombie: corpse to a neighboring location.",
"You may move one character with at least one :paranoia: counter from this location to an adjacent location (not diagonal).",
"You may place 1 :goodwill: counter on a character at this character’s location.",
"You may place 1 :goodwill: on any character in this location.",
"You may place 1 :intrigue: counter on a corpse at this character’s location.",
"You may place 1 :intrigue: counter on this location or an any character in this location.",
"You may place 1 :intrigue: on any location.",
"You may place 1 :intrigue: on this location or on any character in this location.",
"You may place 1 :paranoia: on any character in this location.",
"You may place 1 Intruge counter on the :factor:’s location",
"You may place 1 Intruge on this location or on any character in this location.",
"You may trigger a Warp. Place 2 :paranoia: counters on any character, and 2 :goodwill: counters on any other character.",
"You may trigger a Warp. When determining if this Incident triggers, it always triggers regardless of the number of counters on the culprit.",
"You may, insead of saying the truth, state any other non-:person: role that is in this script",
"Young Girl",
"youngGirl",
"Your Creations",
"zombie",
"Zombie",
"Zombie (Haunted Stage)",
"Zombie Apocalypse",
"zombieApocalypse",
"ZombieHaunted"
] as const;